import {Component, HostBinding, Input, OnInit} from '@angular/core';

@Component({
  selector: 'awair-score-dot',
  templateUrl: './score-dot.component.html',
  styleUrls: ['./score-dot.component.scss']
})
export class ScoreDotComponent implements OnInit {

  @HostBinding('style.backgroundColor') hostBackgroundColor: string = '#CDD3D8';
  @HostBinding('style.width') hostWidth: string = '48px';
  @HostBinding('style.height') hostHeight: string = '48px';
  @Input() score: string;
  @Input()
  set width(value: string) {
    if (value != null) {
      this.hostWidth = value;
    }
  }
  @Input()
  set height(value: string) {
    if (value != null) {
      this.hostHeight = value;
    }
  }

  get isOnline(): boolean {
    if (this._isOnline != null) {
      return this._isOnline;
    }
  }
  @Input()
  set isOnline(value: boolean) {
    if (value != null) {
      this._isOnline = value;
      this.hostBackgroundColor = value ? this.color : '#CDD3D8';
    }
  }
  private _isOnline: boolean = false;

  get color(): string {
    if (this._color != null) {
      return this._color;
    }
  }
  @Input()
  set color(value: string) {
    if (value != null) {
      this.hostBackgroundColor = this.isOnline ? value : '#CDD3D8';
      this._color = value;
    }
  }
  private _color: string;

  constructor() {
  }

  ngOnInit() {
  }
}
